var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamationCircleSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.748 16.107a.5.5 0 0 1-.5.5h-.487a.5.5 0 0 1-.5-.5L13.75 10.5a.5.5 0 0 1 .5-.5h1.498a.5.5 0 0 1 .5.5zM7 15a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
})));
export default SvgExclamationCircleSolid;